import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import IncomingBanksDetailPayments from "./IncomingBanksDetailPayments";
import { IncomingBanksDetailFooter } from "./IncomingBanksDetailFooter";
import { IncomingBankPaymentDto } from "../dtos/IncomingBankPaymentDto";
import { IncomingBanksModel } from "../models/IncomingBanksModel";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { EnumHelper } from "src/helpers/EnumHelper";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupBankAccount } from "src/components/Shared/NewForms/NFLookupBankAccount";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "src/components/Shared/NewForms/NFLookupPaymentRequests";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import IncomingBanksCustomerPaymentDetail from "../OperationTypesDetailsViews/IncomingBanksCustomerPaymentDetail";
import IncomingBanksTransferFromAnotherAccountDetail from "../OperationTypesDetailsViews/IncomingBanksTransferFromAnotherAccountDetail";
import IncomingBanksCashDepositToBankDetail from "../OperationTypesDetailsViews/IncomingBanksCashDepositToBankDetail";
import IncomingBanksLoanRepaymentDetail from "../OperationTypesDetailsViews/IncomingBanksLoanRepaymentDetail";
import IncomingBanksDepositInterestDetail from "../OperationTypesDetailsViews/IncomingBanksDepositInterestDetail";
import IncomingBanksLoanRepaymentByEmployeeDetail from "../OperationTypesDetailsViews/IncomingBanksLoanRepaymentByEmployeeDetail";
import IncomingBanksCurrencyConversionDetail from "../OperationTypesDetailsViews/IncomingBanksCurrencyConversionDetail";
import IncomingBanksOtherPaymentDetail from "../OperationTypesDetailsViews/IncomingBanksOtherPaymentDetail";
import IncomingBanksVendorRefundDetail from "../OperationTypesDetailsViews/IncomingBanksVendorRefundDetail";
import IncomingBanksReturnFromAdvanceHolderDetail from "../OperationTypesDetailsViews/IncomingBanksReturnFromAdvanceHolderDetail";
import { NFLookupBaseDocuments } from "src/components/Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupCashflowItem } from "src/components/Shared/NewForms/NFLookupCashflowItem";
import { useFetchIncomingBankPayment } from "../hooks/fetchDocument";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";

interface IProps {
  id?: string;
}

export const IncomingBanksDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IncomingBanksModel>({
    mode: "onTouched"
  });

  const [tabIndex, setTabIndex] = useState(0);
  // const [fileName, setFileName] = useState("Incoming Banks");
  const { t } = useTranslation();

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchIncomingBankPayment({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.IncomingBanks.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };
  const operationType = watch("operationType");

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs onTabChange={handleTabChange}>
        <NFTab title="Main" />
        <NFTab title="Additional" />
        <NFTab title={"Payments"} />
      </NFTabs>

      {/* <DocumentDetailViewToolbar>
        <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
        <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
        <DetailViewCancelButton onCancel={cancelHandler} />
        <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
    </DocumentDetailViewToolbar> */}
      <DocumentDetailViewToolbar>
        <DetailViewPostButton onPost={handlePost} />
        <DetailViewCancelButton onCancel={handleCancel} />
        {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
        {/*                              fileName={fileName} setFileName={setFileName}/>*/}
      </DocumentDetailViewToolbar>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={"Operation type"} fieldName={"operationType"} items={EnumHelper.GetIncomingBankPaymentType()} />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("Status")} fieldName={"status"} items={EnumHelper.GetPaymentRequestsStatus()} required />
        </Col>
      </Row>

      <NFTabContainer index={0} currentIndex={tabIndex}>
        <Row>
          <Col sm={6}>
            <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
          </Col>
          <Col sm={6}>
            <NFTextInput title={t("Document#")} disabled fieldName={"documentNumber"} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupCompany fieldName="companyId" title={t("Company")} required />
          </Col>
          <Col sm={6}>
            <NFDateInput title={t("PaymentDate")} fieldName={"paymentDate"} required />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} required />
          </Col>
          <Col sm={6}>
            <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required={true} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupInput title={t("AsAListNoSplit")} fieldName={"amountOfPayments"} items={EnumHelper.GetOutgoingBankCashListSplitTypeEnum()} required={true} />
          </Col>
          <Col sm={6}>
            <NFLookupDivision fieldName="divisionId" title={t("Division")} required />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupPaymentRequests fieldName="paymentRequestId" title={t("Payment")} />
          </Col>
          <Col sm={6}>
            <NFIntInput title={t("Amount")} fieldName={"amount"} />
          </Col>
        </Row>

        {operationType === 0 && <IncomingBanksCustomerPaymentDetail />}
        {operationType === 1 && <IncomingBanksTransferFromAnotherAccountDetail />}
        {operationType === 2 && <IncomingBanksCashDepositToBankDetail />}
        {operationType === 3 && <IncomingBanksLoanRepaymentDetail />}
        {operationType === 4 && <IncomingBanksDepositInterestDetail />}
        {operationType === 5 && <IncomingBanksLoanRepaymentByEmployeeDetail />}
        {operationType === 6 && <IncomingBanksCurrencyConversionDetail />}
        {operationType === 7 && <IncomingBanksOtherPaymentDetail />}
        {operationType === 8 && <IncomingBanksVendorRefundDetail />}
        {operationType === 9 && <IncomingBanksReturnFromAdvanceHolderDetail />}
      </NFTabContainer>

      <NFTabContainer index={1} currentIndex={tabIndex}>
        <Row>
          <Col md={6}>
            <NFLookupBaseDocuments title={t("BaseDocument")} fieldName="baseDocumentAtId" />
          </Col>
          <Col md={6}>
            <NFLookupCashflowItem fieldName="cashFlowItemId" title={t("CashFlowItem")} required />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <NFTextInput title={t("CreatedUser")} fieldName={"createdUser"} disabled={true} />
          </Col>
          <Col md={6}>
            <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} required />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <NFTextInput fieldName="comment" title={t("Comment")} />
          </Col>
        </Row>
      </NFTabContainer>
      <NFTabContainer index={2} currentIndex={tabIndex}>
        <IncomingBanksDetailPayments />
      </NFTabContainer>
      <IncomingBanksDetailFooter />
    </FormProvider>
  );
};
